import { entryArtistIds } from '@shared/lineupActs'
import type { Artist } from '../types'
import type { FocalAnchor } from './focalPosition'

export interface SetImages {
  // First artist's photo — the single-image background.
  imageUrl: string | undefined
  // First artist's detected focal point, for positioning that single image.
  focal: FocalAnchor
  // All artists' photos that exist — drives the b2b split-panel background.
  imageUrls: string[]
  // Focal point per `imageUrls` entry, same order — positions each b2b split panel.
  imageFocals: FocalAnchor[]
  // Stable seed for the procedural gradient fallback when there are no photos.
  seed: string
}

/**
 * The artist imagery for a set's (or lineup act's) card background — a named
 * collab's own photo, single image, b2b split, or a gradient seed when no
 * artist has a photo. Shared by the event-page schedule (SetBlock), the lineup
 * and festival-mode set cards so they render the same way.
 */
export function setImages(
  set: { id: string; artistId?: string; artistIds?: string[]; collabArtistId?: string },
  artists: Record<string, Artist>,
): SetImages {
  const ids = entryArtistIds(set)
  const collab = set.collabArtistId ? artists[set.collabArtistId] : undefined
  if (collab?.imageUrl) {
    return { imageUrl: collab.imageUrl, focal: collab, imageUrls: [collab.imageUrl], imageFocals: [collab], seed: collab.id }
  }
  const pictured = ids.map(id => artists[id]).filter((a): a is Artist & { imageUrl: string } => !!a?.imageUrl)
  return {
    imageUrl: artists[ids[0]]?.imageUrl,
    focal: artists[ids[0]],
    imageUrls: pictured.map(a => a.imageUrl),
    imageFocals: pictured,
    seed: set.collabArtistId || ids[0] || set.id,
  }
}
